"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaServerHeader = exports.SpaClientHeader = exports.SpaHeader = exports.SPA_HEADER = void 0;
const react_1 = __importStar(require("react"));
const spa_header_context_1 = require("./spa-header.context");
const spa_util_1 = require("../../../../../common/spa/spa.util");
const stark_util_1 = require("../../../../../common/stark.util");
const spa_header_style_1 = __importDefault(require("./spa-header-style"));
const spa_header_fallback_1 = __importDefault(require("../fallback/spa-header-fallback"));
exports.SPA_HEADER = "spa-header";
/**
 * SpaHeader for client side only apps.
 *
 * @returns React.FC.
 */
const SpaHeader = (headerProps) => {
    const headerContext = (0, react_1.useContext)(spa_header_context_1.SpaClientOnlyHeaderContext);
    const [showFallback, setShowFallback] = (0, react_1.useState)(false);
    const env = headerContext.env;
    const headerOverlayCls = ["spa-header__overlay"];
    if ((0, spa_util_1.isMinimal)(headerContext.pageType)) {
        headerOverlayCls.push("spa-minimal-header__overlay");
    }
    if ((0, spa_util_1.hasSitewideBanner)(headerContext.pageType)) {
        // Show eyebrow placeholder within the header overlay - CSR only pages
        headerOverlayCls.push('spa-header__overlay--eyebrow');
    }
    (0, react_1.useEffect)(() => {
        if ((0, spa_util_1.getQueryParam)('showWrapperFallback') === 'true') {
            // Show fallback content if parameter is set.
            setShowFallback(true);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (!showFallback && (0, spa_util_1.isSuccessfulResponse)(headerProps, true)) {
            const mountElem = document.getElementById(headerContext.mountElemId);
            if (mountElem) {
                mountElem.classList.add(...headerOverlayCls);
                document.addEventListener("spa-header__mounted", () => {
                    mountElem.classList.remove(...headerOverlayCls);
                });
            }
            const headerScript = document.createElement('script');
            headerScript.id = `${exports.SPA_HEADER}-js`;
            headerScript.setAttribute('data-testid', `${exports.SPA_HEADER}-js`);
            headerScript.src = JSON.parse(headerProps.js).content;
            headerScript.async = true;
            document.body.appendChild(headerScript);
        }
    }, []);
    if (showFallback || !(0, spa_util_1.isSuccessfulResponse)(headerProps, true)) {
        // An error occurred when getting props. Show fallback content.
        return react_1.default.createElement(spa_header_fallback_1.default, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(spa_header_style_1.default, null),
        react_1.default.createElement("div", { id: "chewy-header-conf", "data-page-type": headerContext.pageType, "data-mount-el-id": headerContext.mountElemId, "data-csr": headerProps.csr, "data-user-context": headerContext.userContext }),
        react_1.default.createElement("link", { rel: "stylesheet", id: `${exports.SPA_HEADER}-css`, "data-testid": `${exports.SPA_HEADER}-css`, href: (0, spa_util_1.getSpaResourceContent)(headerProps.css), media: "all" }),
        react_1.default.createElement("script", { src: `${(0, stark_util_1.getStarkJs)(env)}`, defer: true, async: true }),
        react_1.default.createElement("link", { rel: "stylesheet", href: `${(0, stark_util_1.getStarkCss)(env)}`, media: "none" })));
};
exports.SpaHeader = SpaHeader;
/**
 * SpaClientHeader for client side of ssr apps.
 *
 * @returns React.FC.
 */
const SpaClientHeader = () => {
    const headerContext = (0, react_1.useContext)(spa_header_context_1.SpaHeaderContext);
    const [showFallback, setShowFallback] = (0, react_1.useState)(false);
    const env = getEnv(headerContext);
    (0, react_1.useEffect)(() => {
        const cssScript = document.getElementById(`${exports.SPA_HEADER}-css`);
        const htmlscript = document.getElementById(`${exports.SPA_HEADER}-html`);
        if (!cssScript || !htmlscript || (0, spa_util_1.getQueryParam)('showWrapperFallback') === 'true') {
            // Show fallback content if css or html is undefined or parameter is set.
            setShowFallback(true);
        }
    }, []);
    if (showFallback) {
        return react_1.default.createElement(spa_header_fallback_1.default, null);
    }
    const internalComponentType = (0, spa_util_1.getInternalComponentType)('header', headerContext.pageType);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: "chewy-header-conf", "data-page-type": headerContext.pageType, "data-mount-el-id": headerContext.mountElemId, "data-user-context": headerContext.userContext }),
        react_1.default.createElement("style", { id: `${exports.SPA_HEADER}-css`, "data-testid": `${exports.SPA_HEADER}-css`, dangerouslySetInnerHTML: { __html: '' } }),
        react_1.default.createElement("div", { id: `${exports.SPA_HEADER}-html`, "data-testid": `${exports.SPA_HEADER}-html`, dangerouslySetInnerHTML: { __html: '' } }),
        react_1.default.createElement("script", { "data-testid": `${exports.SPA_HEADER}-js`, id: `${exports.SPA_HEADER}-js`, src: `${headerContext.baseURL}/${internalComponentType}.js`, async: true }),
        react_1.default.createElement("script", { src: `${(0, stark_util_1.getStarkJs)(env)}`, defer: true, async: true }),
        react_1.default.createElement("link", { rel: "stylesheet", href: `${(0, stark_util_1.getStarkCss)(env)}`, media: "none" })));
};
exports.SpaClientHeader = SpaClientHeader;
/**
 * SpaServerHeader for server side of ssr apps.
 *
 * @returns React.FC.
 */
const SpaServerHeader = (headerProps) => {
    const headerContext = (0, react_1.useContext)(spa_header_context_1.SpaHeaderContext);
    const env = getEnv(headerContext);
    if (!(0, spa_util_1.isSuccessfulResponse)(headerProps)) {
        // An error occurred when getting props. Show fallback content.
        return react_1.default.createElement(spa_header_fallback_1.default, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: "chewy-header-conf", "data-page-type": headerContext.pageType, "data-mount-el-id": headerContext.mountElemId, "data-user-context": headerContext.userContext }),
        react_1.default.createElement("style", { id: `${exports.SPA_HEADER}-css`, "data-testid": `${exports.SPA_HEADER}-css`, dangerouslySetInnerHTML: { __html: (0, spa_util_1.getSpaResourceContent)(headerProps.css) } }),
        react_1.default.createElement("div", { id: `${exports.SPA_HEADER}-html`, "data-testid": `${exports.SPA_HEADER}-html`, dangerouslySetInnerHTML: { __html: (0, spa_util_1.getSpaResourceContent)(headerProps.html, true) } }),
        react_1.default.createElement("script", { id: `${exports.SPA_HEADER}-js`, "data-testid": `${exports.SPA_HEADER}-js`, src: (0, spa_util_1.getSpaResourceContent)(headerProps.js), async: true }),
        react_1.default.createElement("script", { src: `${(0, stark_util_1.getStarkJs)(env)}`, defer: true, async: true }),
        react_1.default.createElement("link", { rel: "stylesheet", href: `${(0, stark_util_1.getStarkCss)(env)}`, media: "none" })));
};
exports.SpaServerHeader = SpaServerHeader;
const getEnv = (headerContext) => {
    // use env from context, when passed by applications.
    if (headerContext.env) {
        return headerContext.env;
    }
    // derive from baseURL.
    return headerContext.baseURL.split('.')[3];
};
//# sourceMappingURL=spa-header.js.map